export default __webpack_public_path__ + "static/user1-e429945892e9248404ee8d0c9a5887da.jpg";